// HOOKS
import { useMutation } from "@apollo/client";
import { useState, useCallback, useEffect } from "react";
// GRAPHQL
import { UPDATE_CUSTOMER } from "../../graphql/mutations/customers/customers.mutations";

const useUpdateCustomer = () => {
  const [timedUpdate, setTimedUpdate] = useState(null);
  const [updateCustomerMutation, { loading, error, data }] =
    useMutation(UPDATE_CUSTOMER);

  const updateCustomer = useCallback(
    async (customer) => {
      if (timedUpdate) clearTimeout(timedUpdate);

      const timeout = setTimeout(() => {
        const allowedFields = [
          "id","daily_invoices",
          "purchase_order_email"
        ];

        const filteredCustomer = Object.entries(customer)
          .filter(([key]) => allowedFields.includes(key))
          .reduce((obj, [key, value]) => {
            obj[key] = key === "purchase_order_email" && Array.isArray(value)
              ? value.map(({ email }) => ({ email }))
              : value;
            return obj;
          }, {});

        updateCustomerMutation({
          variables: { id: customer.id, customer: filteredCustomer },
        }).catch((apolloError) => {
          console.error(`Apollo error updating customer: ${apolloError.message}`);
          alert(`Apollo error updating customer: ${apolloError.message}`);
        });
      }, 800);

      setTimedUpdate(() => timeout);
    },
    [updateCustomerMutation, timedUpdate]
  );

  useEffect(() => {
    return () => {
      if (timedUpdate) clearTimeout(timedUpdate);
    };
  }, [timedUpdate]);

  return { updateCustomer, loading, error, data };
};

export default useUpdateCustomer;
